import { useEffect, useState, useContext } from 'react';
import { WhatsappContext } from 'contexts/WhatsappContext';
import { Typography, Box } from '@mui/material';
import Container from 'components/Container';
import Button from 'components/Button';

const WhatsApp = () => {
  const [event, setEvent] = useState({});
  const { postLogin } = useContext(WhatsappContext);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';

    script.onload = () => {
      window.FB.init({
        appId: process.env.REACT_APP_WHATSAPP_CLIENT_ID,
        cookie: true,
        xfbml: true,
        version: process.env.REACT_APP_WHATSAPP_GRAPH_API_VERSION,
      });
    };

    window.addEventListener('message', (evt) => {
      if (!evt.origin.endsWith('facebook.com')) return;

      try {
        const data = JSON.parse(evt?.data || {});
        if (data?.type === 'WA_EMBEDDED_SIGNUP') {
          if (data?.data) {
            setEvent((prev) => ({ ...prev, ...data?.data }));
          }
        }
      } catch {}
    });

    document.body.appendChild(script);
  }, []);

  const handleLogin = () => {
    window.FB.login(
      (response) => {
        setEvent((prev) => {
          const data = { ...prev, ...(response?.authResponse || {}) };

          if (
            data?.code &&
            (data?.business_id || data?.phone_number_id || data?.waba_id)
          ) {
            postLogin({ data });
          }

          return data;
        });
      },
      {
        config_id: process.env.REACT_APP_WHATSAPP_EMBEDDED_CONFIG_ID,
        response_type: 'code',
        override_default_response_type: true,
        extras: {
          setup: {},
          featureType: 'whatsapp_business_app_onboarding',
          sessionInfoVersion: '3',
        },
      }
    );
  };

  const handleLogout = () => {
    window.FB.logout((r) => {
      console.log(r);
    });
  };

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <Typography variant="h5" gutterBottom>
          Login com Facebook
        </Typography>
        <Button variant="contained" color="primary" onClick={handleLogin}>
          Entrar com Facebook
        </Button>
      </Box>
    </Container>
  );
};

export default WhatsApp;
